import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { MomentInput } from 'moment';

@Pipe({ name: 'momentFormat' })
export class MomentFormatPipe implements PipeTransform {
    transform(value: MomentInput, format: string, isLocale: boolean = false) {
        if (value == null || value === '') {
            return '';
        }
        if (isLocale) {
            // Value may be a Date (from table type:'date') or ISO string like "2026-02-06T00:00:00"
            if (value instanceof Date) {
                return moment(value).format(format);
            }
            const str = String(value);
            const asUtc = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str) && !/Z|[+-]\d{2}:?\d{2}$/.test(str)
                ? str + 'Z'
                : str;
            return moment(asUtc).format(format);
        }
        return moment(value).format(format);
    }
}
